import { define, type, auto, Record, Collection } from 'type-r'

import ValidRecord from './valid_record'
import DOB from '#metatypes/dob.js'
import PowerBool from '#metatypes/power_bool.js'

@define 
export class IncidentInfo extends ValidRecord {
    @(type(PowerBool).as) confirmed: boolean
    @(type(String).as) when: string
}
